'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoBriefcase = function IoBriefcase(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm18.8 21.3v-0.7h16.2v13.8c0 0.3-0.3 0.6-0.6 0.6h-33.8c-0.3 0-0.6-0.3-0.6-0.6v-13.8h16.3v0.7h2.5z m15.6-10c0.3 0 0.6 0.3 0.6 0.6v7.5h-16.2v-0.6h-2.5v0.6h-16.3v-7.5c0-0.3 0.3-0.6 0.6-0.6h9.4v-2.5c0.1-2.2 1.7-3.8 4-3.8h7c2.4 0 3.9 1.6 4 3.8v2.5h9.4z m-11.9-2.2v-0.1c0-0.8-0.7-1.5-1.5-1.5h-7c-0.8 0-1.5 0.7-1.5 1.5v2.3h10v-2.2z' })
        )
    );
};

exports.default = IoBriefcase;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/briefcase.js
// module id = 2452
// module chunks = 168707334958949